module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/F0018572_login.7a583c03.png";